import { Navigate } from "react-router-dom"
import Home from './../views/Home/Home'
import ItemDetail from '../views/Detail';
import About from '../views/About/About';
import Setting from '../views/Settings/Setting';
import UssdPage from "../views/Home/UssdPage";
import SupportOnline from '../views/Home/SupportOnline';
import About2 from '../views/About/About2';

const mainRoutes = [
    {
        path: "/",
        component: Home,
    },
    {
        path: "/details/:id",
        component: ItemDetail,
    },
    {
        path: "/about",
        component: About,
    },
    {
        path: "/setting",
        component: Setting,
    },
    {
        path: "/ussd",
        component: UssdPage,
    },
    {
        path: "/detail/1",
        component: () => <Navigate to="/" replace />
    },
    {
        path: "/support-online",
        component: SupportOnline,
    },
    {
        path: "/about2",
        component: About2,
    },

];

export default mainRoutes;
